import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: absolute;
  height: 55px;
  top: ${(props) => (props.top ? `${props.top}px` : "90px")};
  left: 0;
  width: 100vw;
  background: #ec5050;
  z-index: 0;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.delay {
    animation-delay: 1s;
  }

  ${mediaMaxWidth.smallDesktop`
    top: ${(props) => (props.top ? `${props.top}px` : "50px")};
  `}
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 1000px;
  height: 100%;
  margin: 0 auto;

  ${mediaMaxWidth.mediumDesktop`
    width: 900px;
  `}

  ${mediaMaxWidth.smallDesktop`
    width: 750px;
  `}

  ${mediaMaxWidth.tablet`
    width: 95vw;
  `}
`;

export const Text = styled.div`
  display: table;
  color: #fff;
`;

export const Line = styled.div`
  display: flex;
  flex: 1;
  font-size: 0.85em;
  font-weight: 400;
  word-spacing: 1px;
  letter-spacing: 0.5px;

  strong {
    margin: 0 5px;

    &:nth-child(2) {
      margin: 0 0 0 5px;
    }
  }

  ${mediaMaxWidth.tablet`
    font-size: 0.75em;
    word-spacing: unset;
    letter-spacing: unset;
  `}
`;

export const Link = styled.a`
  margin: 0 0 0 5px;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
  transition: 0.1s ease-in-out;
  text-decoration: underline;

  &:nth-child(2) {
    margin: 0 5px;
  }

  &:hover {
    color: #333;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 30px;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.4em;
  cursor: pointer;
  color: #fff;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #333;
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.2em;
  `}
`;
